import 'chart.js/auto';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import styles from './network.module.scss';

const NetworkTraffic = ({ header, networkTraffic }) => {
  const rows = (networkTraffic+"").trim().split('\n').slice(1);
  const labels = header;

  const dataSets = rows.map(row => {
    const header1 = row.trim().split(/\s+/);
    return {
      label: header1[0],
      data: header1.slice(1).map(item => parseFloat(item)),
      backgroundColor: `hsla(${Math.random() * 360}, 80%, 65%, 0.8)`,
      borderColor: `hsla(${Math.random() * 360}, 80%, 45%, 1)`,
      borderWidth: 0, // 막대 테두리 두께
    };
  });

  const hasData = dataSets.some(dataset => dataset.data.some(value => value !== '' && value !== 'N/A'));

  const data = {
    labels,
    datasets: hasData ? dataSets : [],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 20, // 범례 폰트 크기 증가
            weight: 'bold'
          },
          padding: 20 // 범례 항목 간 간격
        },
      },
      tooltip: {
        titleFont: {
          size: 16
        },
        bodyFont: {
          size: 14
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 16  // X축 레이블 폰트 크기
          }
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 16  // Y축 레이블 폰트 크기
          }
        }
      }
    },
    barThickness: 20, // 막대 두께
  };

  return (
    <div className={styles.network_traffic_container}>
      <h2 style={{ fontSize: '24px', marginBottom: '20px' }}>Network Traffic</h2>
      <Bar data={data} options={options} />
    </div>
  );
};

export default NetworkTraffic;
